import React from 'react';
import { useSelector } from 'react-redux';
import { selectorsResponsive } from '@app/store/conversations';
import ConversationView from './ConversationView';
import AllConversationView from './AllConversationView';
import MessageWidgetCard from './MessageWidgetCard';

const MessagesWidget = () => {
  const paginatedConversations = useSelector(
    selectorsResponsive.paginatedConversations
  );

  const [isConversationDialogOpen, setIsConversationDialogOpen] =
    React.useState(false);
  const [isAllConversationsDialogOpen, setIsAllConversationsDialogOpen] =
    React.useState(false);

  const handleConversationClick = (conversationId: string) => {
    setIsConversationDialogOpen(true);
    window.location.href = `/#/home/messages/${conversationId}`;
  };

  const handleConversationDialogClose = () => {
    setIsConversationDialogOpen(false);
    window.location.href = `/#/home`;
  };

  return (
    <>
      <MessageWidgetCard
        setIsAllConversationsDialogOpen={setIsAllConversationsDialogOpen}
        paginatedConversations={paginatedConversations}
        handleConversationClick={handleConversationClick}
      />

      <ConversationView
        isConversationDialogOpen={isConversationDialogOpen}
        handleConversationDialogClose={handleConversationDialogClose}
      />

      <AllConversationView
        isAllConversationsDialogOpen={isAllConversationsDialogOpen}
        setIsAllConversationsDialogOpen={setIsAllConversationsDialogOpen}
        paginatedConversations={paginatedConversations}
        handleConversationClick={handleConversationClick}
      />
    </>
  );
};

export default MessagesWidget;
